<template>
  <div class="StudentHistory">
    <h1 class="m-label" style="margin: 0">対応履歴</h1>
    <div style="height: calc(100vh - 262px);">

      <transition name="loading" mode="out-in">
        <template v-if="student.family.familysupports">

          <div>

            <div :class="condition.condition ? 'm-support__inner is-shrink' : 'm-support__inner is-normal'" class="is-print-overflow">
              <div v-bind:class="{ 'small': type }">

                <p>
                  <span class="fa" @click=''><i class="fa fa-fw fa-filter"></i>フィルター<i class="fa fa-fw fa-angle-down"></i></span>
                  <span class="fa" @click='sort("support_date")'><i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i></span>
                  <span>
                    <template v-if="this.sortColumn === 'support_date'">対応日</template>
                    : {{sortState}}
                  </span>
                </p>

                <ul class="m-supportList">
                  <li class="m-supportItem m-supportItem--happy" v-for="(list, index) in mapFamilysupports" :key="index.id" transition="expand">
                    <template v-if="list.support_tags">
                      <template v-if="list.support_tags.length > 0">
                        <div class="m-supportItem__border" v-bind:style="{ 'backgroundColor': list.support_tags[0].tag.color }"></div>
                      </template>
                      <template v-else>
                        <div class="m-supportItem__border" v-bind:style="{ 'backgroundColor': '#607D8B' }"></div>
                      </template>
                    </template>
                    <!-- xxx <p style="margin: 10px"><strong>{{"#"+list.id}}</strong></p> -->
                    <div class="m-supportItem__header">

                      <div class="m-supportItem__avatar">
                        <template v-if="list.user">
                          <div class="user-icon-history">{{(list.user.user).charAt(0)}}</div>
                        </template>
                        <template v-else>
                          <div class="user-icon-history">未</div>
                          <p>{{list.user_id}}</p>
                        </template>
                      </div>
                      <time>
                        <!-- {{list.id}} -->
                        <template v-if="list.user">
                          <p>{{list.user.user}}</p>
                        </template>
                        <p>{{list.mapSupport_date}}</p>
                        <ul class="m-link is-print-none">
                          <li><a @click="edit(list)"><i class="fa fa-edit"></i>編集</a> <a @click="deleteStudentsupport(list)"><i class="fa fa-trash-o"></i>削除</a></li>
                        </ul>
                      </time>

                      <div class="tagInput is-print-none">
                        <i class="fa fa-tag"></i>
                        <multiselect @select="select" v-model="tag" :options="tags" label="name" :show-labels="false" placeholder="タグ追加"></multiselect>
                        <i @click="postSupportTag(list)" class="fa fa-plus"></i>
                      </div>

                      <div class="m-tag">
                        <span v-for="list in list.support_tags" :key="list.id">
                          <tag v-bind:style="{ 'backgroundColor': list.tag.color }"><i @click="deleteSupportTag(list)" class="fa fa-fw fa-times"></i>{{list.tag.name}}</tag>
                        </span>
                      </div>

                    </div>

                    <template v-if="list.id == edit_id.list_id">
                      <div class="m-supportItem__main">
                        <vue-html5-editor @change="patchNote(list, $event)" :content="list.note" :auto-height="false"></vue-html5-editor>
                        <div style="display: flex">
                          <input type='text' class="support_date" v-model="patch.support_date" placeholder="対応日" key="edit_id-input">
                        </div>
                        <div class="m-supportItem__edit-btn">
                          <button @click="patchStudentsupport(list)">更新</button><button @click="cancelStudentsupport">キャンセル</button>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="m-supportItem__main"><div class="vue-html" v-html="list.note"></div></div>
                    </template>
                  </li>
                </ul>
              </div>
            </div>

            <div :class="condition.condition ? 'm-support__inner2 is-show' : 'm-support__inner2 is-hide'">
              <div v-bind:class="{ 'small': type }">
                <div class="m-supportItem2">
                  <div class="m-supportItem2__border m-supportItem2__border--add"></div>
                  <div class="m-supportItem2__header">
                  </div>
                  <div class="m-supportItem2__main">
                    <vue-html5-editor @change="changeNote" :content="support.note" :auto-heihght="false"></vue-html5-editor>
                    <div style="display: flex">
                      <input type='text' class="support_date" v-model="support.support_date" placeholder="対応日">
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </template>
        <template v-else>
          <loading></loading>
        </template>
      </transition>

    </div>
    <template v-if="condition.condition == false">
      <btn class="is-print-none" @click.native="slide"><i class="fa fa-chevron-circle-up"></i>対応履歴入力</btn>
    </template>
    <template v-else>
      <div style="display: flex">
        <btn @click.native="postSupport"><i class="fa fa-pencil"></i>新規追加</btn>
        <btn @click.native="slide" class="support-cxl">キャンセル</btn>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment'

let _ = window._
export default {
  props: {
    student: Object,
    type: String,
    condition: Object,
    edit_id: Object
  },
  computed: {
    tags () {
      return this.$store.getters.tags
    },

    // order By
    orderedFamilysupports () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.student.family.familysupports, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.student.family.familysupports, this.sortColumn)
      }
    },

    // map
    mapFamilysupports () {
      let self = this
      return self.orderedFamilysupports.map((familysupport) => {
        familysupport.mapSupport_date = self.calcDateTime(familysupport.support_date)
        return familysupport
      })
    }
  },
  name: 'StudentHistory',
  data () {
    return {
      sortState: '降順',
      sortColumn: 'support_date',
      tag: '',
      support: {
        note: '',
        support_date: new Date()
      },
      patch: {
        support_date: ''
      }
    }
  },
  methods: {
    calcDateTime (val) {
      const datetime = new Date(val)
      const year = datetime.getFullYear()
      let month = datetime.getMonth() + 1
      month = month.toString()
      month = month.padStart(2, '0')
      let date = datetime.getDate()
      date = date.toString()
      date = date.padStart(2, '0')
      let hours = datetime.getHours()
      hours = hours.toString()
      hours = hours.padStart(2, '0')
      let minutes = datetime.getMinutes()
      minutes = minutes.toString()
      minutes = minutes.padStart(2, '0')
      return year + '/' + month + '/' + date + ' ' + hours + ':' + minutes
    },

    select (selectedOption, id) {
      // console.log(selectedOption)
    },

    // order By
    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    changeNote (data) {
      this.support.note = data
    },

    patchNote (list, $event) {
      list.note = $event
      // console.log($event)
      // console.log(list)
    },

    slide () {
      this.condition.condition = !this.condition.condition
    },

    postSupport () {
      this.$store.dispatch('postSupport', {
        this: this,
        condition: this.condition,
        support: this.support
      })
    },

    edit (list) {
      this.edit_id.list_id = list.id
      this.patch.support_date = this.calcDateTime(list.support_date)
    },

    cancelStudentsupport (list) {
      this.$store.dispatch('cancelStudentsupport', {
        edit_id: this.edit_id
      })
    },

    patchStudentsupport (list) {
      this.$store.dispatch('patchStudentsupport', {
        this: this,
        edit_id: this.edit_id,
        list: list,
        patch: this.patch
      })
    },

    deleteStudentsupport (list) {
      this.$store.dispatch('deleteStudentsupport', list)
    },

    postSupportTag (list) {
      if (this.tag === '') {
        return alert('タグを選んでください。')
      } else {
        this.$store.dispatch('postSupportTag', {
          this: this,
          tag: this.tag,
          list: list
        })
      }
    },

    deleteSupportTag (list) {
      this.$store.dispatch('deleteSupportTag', {
        this: this,
        list: list
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.edit_id.list_id) {
      alert('対応履歴が編集中です')
      return
    } else if (this.condition.condition) {
      alert('対応履歴が編集中です')
      return
    }
    next()
  },
  mounted () {
    let that = this
    function timer () {
      moment.lang('ja')
      that.support.support_date = moment().format('YYYY/MM/DD HH:mm')
      // setTimeout(timer, 1000) // 新規登録時に変更できなくなったのでコメントアウト
    }
    setTimeout(() => {
      timer()
    }, 1000)
  },
  route: {
  }
}
</script>

<style lang='scss' scoped>
.loading-leave-active {
  transition: opacity 0s;
  opacity: 0;
}
.loading-enter-active /* .fade-leave-active below version 2.1.8 */ {
  transition: opacity 2s;
}

.fa-microphone, .fa-headphones {
  font-size: 20px;
  padding: 5px;
  width: 100%;
  text-align: right;
}

.fa-tag, .fa-plus {
  font-size: 15px;
  padding: 5px;
  height: 27px;
}

.vue-html {
  line-height: 1.8;
  text-align: justify;
}

.fa {
  cursor: pointer;
}
.tagInput {
  display: flex;
  border-radius: 15px;
  height: 27px;
  margin: 0 auto;
}
.user-icon-history {
  width: 50px;
  height: 50px;
  margin: 0 10px 0 10px;
  padding: 13px;
  font-size: 20px;
  border-radius: 50px;
  background: #41B883;
  color: #fff;
}
.vue-html5-editor {
  border: none !important;
  .toolbar ul {
    padding: 0;
  }
}
.expand-transition {
  transition: all .3s ease;
  overflow: hidden;
}
.expand-enter, .expand-leave {
  height: 0;
  opacity: 0;
}
.m-support__inner {
  overflow-y: scroll;
  border: 1px solid #eee;
  transition: height .5s ease-in-out;
  &.is-shrink {
    height: calc(calc(100vh - 262px) - calc(calc(100vh - 262px) * 0.5));
  }
  &.is-normal {
    height: calc(100vh - 262px);
  }
}
.m-support__inner2 {
  height: calc(calc(100vh - 262px) * 0.5);
  overflow: scroll;
  border: 1px solid #eee;
  transition: opacity .0s ease-in-out;
  &.is-show {
    position: relative;
    top: 0;
    transition: opacity .3s ease-in-out .4s;
  }
  &.is-hide {
    position: absolut;
    bottom: 0;
    border: none;
    height: 0;
    opacity: 0;
  }
}
.support-cxl {
  margin: 0 !important;
}
.m-supportList {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.m-supportItem {
  position: relative;
  display: flex;
  /* min-height: 200px; */
  padding: 10px 0 10px;
  border-bottom: 2px solid #607D8B;
}
.m-supportItem2 {
  position: relative;
  display: flex;
  min-height: calc((calc(100vh - 262px) - 18px) * 0.5);
  padding: 10px 0;
}
.small {
  .m-supportItem {
    flex-direction: column;
  }
}
.small {
  .m-supportItem2 {
    flex-direction: column;
  }
}
.m-supportItem__border {
  position: absolute;
  top: 0;
  left: 200px;
  width: 3px;
  height: 100%;
  background-color: #607D8B;
}
.m-supportItem2__border {
  position: absolute;
  top: 0;
  left: 200px;
  width: 3px;
  height: 100%;
  background-color: #607D8B;
}
.small {
  .m-supportItem__border {
    left: 0;
  }
}
.small {
  .m-supportItem2__border {
    left: 0;
  }
}
.m-supportItem__header {
  display: flex;
  flex-wrap: wrap;
  flex-basis: 200px;
  min-width: 200px;
  text-align: center;
  &--add {
    background-color: #607D8B;
  }
}
.m-supportItem2__header {
  flex-basis: 200px;
  min-width: 200px;
  text-align: center;
  &--add {
    background-color: #607D8B;
  }
}
.small {
  .m-supportItem__header {
    flex-basis: auto;
  }
}
.small {
  .m-supportItem2__header {
    flex-basis: auto;
  }
}
.m-supportItem__main {
  width: 100%;
  padding: 0 1em;
  font-size: 12px;
  input.support_date {
    bottom: 89;
    right: 1.5em;
    width: 110px;
    border-top: solid 1px #eee;
    border-left: solid 1px #eee;
    border-bottom: none;
    border-right: none;
  }
}
.m-supportItem2__main {
  width: 100%;
  padding: 0 1em;
  font-size: 12px;
  input.support_date {
    bottom: 89;
    right: 1.5em;
    width: 110px;
    border-top: solid 1px #eee;
    border-left: solid 1px #eee;
    border-bottom: solid 1px #eee;
    border-right: none;
  }
}
.m-supportItem__edit-btn {
  display: flex;
  button {
    flex-basis: 50%;
    background: #37474F;
    color: #fff;
    padding: 0;
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
    padding: .5em;
    border: 0;
    cursor: pointer;
    transition: opacity 0.5s ease-in-out;
    &:hover {
      opacity: .8;
    }
  }
}
.small {
  .m-supportItem__main {
    padding: 0 1em;
  }
}
.small {
  .m-supportItem2__main {
    padding: 0 1em;
  }
}
.m-supportItem__avatar {
  p {
    font-size: .8em;
    margin: 5px;
  }
}
time {
  text-align: left;
  p {
    margin: 5px 0;
    font-size: 12px;
  }
}
.m-tag {
  flex-basis: 100%;
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: center;
}
.m-link {
  padding :0;
  list-style-type: none;
  li {
    display: block;
    text-align: left;
    margin: 5px 0;
    a {
      cursor: pointer;
    }
  }
}
.fa-chevron-circle-up {
  margin: 0 5px;
}
.fa-pencil {
  margin-right: 5px;
  font-weight: bold;
}
</style>

<style lang="scss">
.StudentHistory {
  .multiselect {
    min-height: 26px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: 1px solid #ccc;
    border-radius: 5px;
    min-height: 26px;
    padding: 0px 40px 0 2px;
    font-size: .85rem;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 26px;
    font-size: .85rem;
  }
  .multiselect__select {
    width: 25px;
    padding: 4px 4px;
    height: 26px;
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .multiselect__placeholder {
    padding: .5rem 3px;
    margin: 0;
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// StudentHistory.vue?132cd469